import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataTableAccountTransactions from "./DataTableAccountTransactions";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SellingService from "../../../services/SellingService";
const DetailsSoldeFournisseur = ({ startLoading, stopLoading }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [listTransaction, setListTransaction] = useState([{}]);
  const [tier, setTier] = useState();
  const [tierAccount, setTierAccount] = useState();
const [isCodeValid, setIsCodeValid] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [show, setShow] = useState(false); // Modal visibility
  const CONFIDENTIAL_CODE = "SECRET123"; // Static confidentiality code
  const [newPricehtc, setNewPricehtc] = useState(0);

    const [confidentialCode, setConfidentialCode] = useState("");
    const [newValue, setNewValue] = useState("");
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setConfidentialCode("");
    setNewValue("");
    setIsCodeValid(false);
  };

      const handleConfidentialCodeChange = (e) => {
    setConfidentialCode(e.target.value);

    // Check if the entered code matches the static code
    if (e.target.value === CONFIDENTIAL_CODE) {
      setIsCodeValid(true);
    } else {
      setIsCodeValid(false);
    }
  };

  useEffect(() => {
    startLoading();

    TierAccountService.findTransactionByAccountFournisseur(
      getCurrentUserId(),
      localStorage.getItem("idAccountSolde")
    )
      .then((response) => {
        const sorted = [...response.data].sort(
          (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
        );
        setListTransaction(sorted);
        setTier(sorted[0].tier);
        setTierAccount(sorted[0].tiersAccount);
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

     const handleUpdatePrice = async () => {
            try {
            
              console.log("selectedRow",selectedRow)
              let model={
                idUser: getCurrentUserId(),
                idAccount: localStorage.getItem("idAccountSolde"),
                newSolde:newPricehtc
              }
            
              // Update product quantity
              await SellingService.updateTiersAccountSolde(
               model
              );
      
              window.location.reload();
      
              isCodeValid(false)
              handleClose();
            } catch (error) {
              // Handle errors gracefully
              console.error('Error updating price product:', error);
            }
          };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              {tier && (
                <div style={{
                  background: "#111",
                  borderRadius: 6,
                  padding: "20px 28px",
                  marginTop: 16,
                  marginBottom: 16,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 16,
                  boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
                }}>
                  {/* Left — identité */}
                  <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                    <div style={{
                      width: 52, height: 52, borderRadius: "50%",
                      background: "#fff", display: "flex", alignItems: "center",
                      justifyContent: "center", flexShrink: 0,
                    }}>
                      <i className="fas fa-truck" style={{ fontSize: 22, color: "#111" }}></i>
                    </div>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "1.05rem", letterSpacing: 0.3 }}>
                        {tier?.title}
                      </div>
                      <div style={{ color: "#aaa", fontSize: "0.78rem", marginTop: 3 }}>
                        <i className="fas fa-id-card mr-1"></i>
                        {tier.matricule} / {tier.codeCategorie} / {tier.codeTVA} / {tier.numberEtabSecondaire}
                      </div>
                      <div style={{ color: "#aaa", fontSize: "0.78rem", marginTop: 2 }}>
                        <i className="fas fa-map-marker-alt mr-1"></i>
                        {tier.adresse}
                      </div>
                    </div>
                  </div>

                  {/* Right — solde */}
                  {tierAccount && (
                    <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap" }}>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ color: "#aaa", fontSize: "0.72rem", textTransform: "uppercase", letterSpacing: 1 }}>
                          Solde du compte
                        </div>
                        <div style={{
                          fontSize: "1.5rem", fontWeight: 800,
                          color: Number(tierAccount?.solde) >= 0 ? "#69f0ae" : "#ff5252",
                          letterSpacing: 0.5,
                        }}>
                          {parseFloat(Number(tierAccount?.solde).toFixed(3))} DNT
                        </div>
                      </div>
                      <button
                        style={{
                          background: "#fff", color: "#111", border: "none",
                          borderRadius: 4, padding: "8px 16px", fontWeight: 700,
                          fontSize: "0.82rem", cursor: "pointer", display: "flex",
                          alignItems: "center", gap: 6,
                          transition: "opacity 0.2s",
                        }}
                        onMouseOver={e => e.currentTarget.style.opacity = 0.85}
                        onMouseOut={e => e.currentTarget.style.opacity = 1}
                        onClick={() => { setSelectedRow(tierAccount); handleShow(); }}
                      >
                        <i className="fas fa-pen"></i> Modifier solde
                      </button>
                    </div>
                  )}
                </div>
              )}

              {listTransaction.length > 0 && (
                <DataTableAccountTransactions
                  listTransaction={listTransaction}
                  tierAccount={tierAccount}
                />
              )}
            </div>
          </div>
        </div>
      </div>
       <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header>
                      <Modal.Title>Modifier le solde du compte bancaire</Modal.Title>
                      <button className="close" onClick={handleClose}>
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </Modal.Header>
                    <Modal.Body>
                     
                      <hr />
                      <p>
                        Veuillez entrer le code de confidentialité pour continuer :
                      </p>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Entrez le code de confidentialité"
                        value={confidentialCode}
                        onChange={handleConfidentialCodeChange}
                      />
                      {isCodeValid && (
                        <>
                          <br />
                          <p>Code valide. Modifiez les valeurs ci-dessous :</p>
                            <div>
                            <label>Solde :</label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Entrez le nouveau prix"
                              value={newPricehtc}
                              onChange={(e) => setNewPricehtc(e.target.value)}
                            />
                          </div>
            
            
                        </>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="success"
                        onClick={handleUpdatePrice}
                        disabled={!isCodeValid}
                      >
                        Changer le solde
                      </Button>
                    </Modal.Footer>
                  </Modal>
    </div>
  );
};
export default withLoader(DetailsSoldeFournisseur);
